import script from "./MembershipPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./MembershipPlans.vue?vue&type=script&setup=true&lang=js"

import "./MembershipPlans.vue?vue&type=style&index=0&id=4dc475ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc475ee"]])

export default __exports__